const FirestoreCollection = {
    QUOTATIONS: 'Quotations'
};

module.exports = FirestoreCollection;